/**
 * Game mode types and constants for the web landing form
 */

export const GAME_MODES = {
  SHENGJI: 'shengji',
  FINDING_FRIENDS: 'finding-friends',
} as const;

export type GameMode = (typeof GAME_MODES)[keyof typeof GAME_MODES];
